module.exports = __webpack_public_path__ + "assets/2991cfe82f7bff329a05c0ef011a237c.json";